import { type Movie, ScreenType, type Tv } from '@tmdb-graphql-api/schema/types';
import { shuffle } from 'lodash-es';
import { type TileItem } from '#components/Tile/types.ts';
import { formatMovie, formatTv } from '#helpers/formatMoviesAndTvResults.ts';
import { type Config } from '#types.ts';

export type OrderMapper = { id: string; type: ScreenType }[];

export const mergeFormattedMoviesAndTvResults = (movies: TileItem[], tv: TileItem[], orderMapper: OrderMapper) => {
  const orderedResults: TileItem[] = [];

  for (const { id, type } of orderMapper) {
    if (type === ScreenType.Movie) {
      const match = movies.find(entry => entry.id === id);

      if (match) {
        orderedResults.push(match);
      }
    } else {
      const match = tv.find(entry => entry.id === id);

      if (match) {
        orderedResults.push(match);
      }
    }
  }

  return orderedResults;
};

export const formatAndMergeMoviesAndTvResults = (
  movieData: Movie[] | undefined,
  tvData: Tv[] | undefined,
  config: Config,
  orderMapper?: OrderMapper,
): TileItem[] => {
  const formattedMovieData = (movieData ?? []).map(entry => formatMovie(entry, config));
  const formattedTvData = (tvData ?? []).map(entry => formatTv(entry, config));

  if (!orderMapper) {
    return shuffle([...formattedMovieData, ...formattedTvData]);
  }

  return mergeFormattedMoviesAndTvResults(formattedMovieData, formattedTvData, orderMapper);
};
